import Joi from 'joi';

import { FileAttachment } from '../db/types';
import i18n, { i18nNS } from '../i18n';

export const requiredString = Joi.string()
  .required()
  .messages({
    'string.base': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
    'string.empty': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
    'any.required': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
  });

export const requiredNumber = Joi.number()
  .required()
  .messages({
    'number.base': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
    'number.empty': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
    'any.required': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
  });

export const requiredPrecisionNumber = ({ precision }: { precision: number }) =>
  Joi.number()
    .required()
    .precision(precision)
    .messages({
      'number.empty': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
      'number.base': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
      'any.required': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
    });

export const optionalString = Joi.string().allow('', null).optional();

export const requiredEmail = Joi.string()
  .required()
  .email({ tlds: { allow: false } })
  .messages({
    'string.base': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
    'string.empty': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
    'any.required': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
    'string.email': i18n.t('please_enter_a_valid_email_address', { ns: i18nNS.VALIDATION }),
  });

export const requiredUrl = Joi.string()
  .uri({ domain: { minDomainSegments: 2, tlds: { allow: false } } })
  .required()
  .messages({
    'string.base': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
    'string.empty': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
    'any.required': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
    'string.uri': i18n.t('invalid_url', { ns: i18nNS.VALIDATION }),
    'string.domain': i18n.t('invalid_url', { ns: i18nNS.VALIDATION }),
  });

export const optionalUrl = Joi.string()
  .uri({ domain: { minDomainSegments: 2, tlds: { allow: false } } })
  .optional()
  .allow('')
  .messages({
    'string.uri': i18n.t('invalid_url', { ns: i18nNS.VALIDATION }),
    'string.domain': i18n.t('invalid_url', { ns: i18nNS.VALIDATION }),
  });

export const requiredBoolean = Joi.boolean()
  .required()
  .messages({
    'boolean.base': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
    'any.required': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
  });

export const requiredInteger = Joi.number()
  .required()
  .integer()
  .messages({
    'number.empty': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
    'number.base': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
    'any.required': i18n.t('this_field_is_required', { ns: i18nNS.VALIDATION }),
  });

export const requiredOneOption = ({ options }: { options: string[] }) =>
  Joi.string()
    .required()
    .valid(...options)
    .messages({
      'string.base': i18n.t('please_select_one_option', { ns: i18nNS.VALIDATION }),
      'string.empty': i18n.t('please_select_one_option', { ns: i18nNS.VALIDATION }),
      'any.only': i18n.t('please_select_one_option', { ns: i18nNS.VALIDATION }),
    });

export const attachment = Joi.object<FileAttachment, true>({
  name: requiredString,
  extension: requiredString,
  originalName: requiredString,
});

export const attachments = Joi.array().items(attachment);
